import React from 'react';
import Select, { components } from 'react-select';
import PropTypes from 'prop-types';

const DropdownIndicator = (props) => (
  <components.DropdownIndicator {...props}>
    <svg width="15" height="15" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="caret-down" className="svg-inline--fa fa-caret-down fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path style={{ fill: '#c0c0c0' }} fill="currentColor" d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path></svg>
  </components.DropdownIndicator>
);

const MultiSelect = ({
  input,
  options,
  placeholder,
  classNamePrefix,
  ...rest
}) => (
  <Select
    {...rest}
    classNamePrefix={classNamePrefix}
    components={{ placeholder, DropdownIndicator }}
    value={input.value}
    theme={(provided) => ({
      ...provided,
      colors: { ...provided.colors, primary: 'transparent' },
    })}
    styles={{
      // "Collapse" the input when it's not focused.
      valueContainer: (provided, state) =>
        state.selectProps.focused ? provided : { ...provided, maxHeight: '30', overflow: 'hidden' },
      indicatorsContainer: (provided, state) =>
        state.selectProps.focused ? provided : { ...provided, maxHeight: '38' },
      container: (provided, state) =>
        state.selectProps.focused ? provided : { ...provided, maxHeight: '38', overflow: 'hidden' },
    }}
    onChange={(val) => input.onChange(val)}
    onBlur={() => input.onBlur(input.value)}
    onFocus={() => input.onFocus()}
    options={options}
    isMulti
  />
);

MultiSelect.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
  }).isRequired,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  classNamePrefix: PropTypes.string,
};

MultiSelect.defaultProps = {
  options: [],
  placeholder: '',
  classNamePrefix: '',
};

export default MultiSelect;



// WEBPACK FOOTER //
// ./src/components/MultiSelect/index.js